// extracted by mini-css-extract-plugin
export default {"column":"ProposalColumn_column__1+4Yd"};